export default {
	methods: {
		goToRoute(routeName) {
			const query = this.$route.query;

			this.$router.push({ name: routeName, query: query });
		},
	}
}